import type { IconData } from '@stacksjs/iconify-core'

export const chessPawn: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M15 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0\"/><path d=\"M18.643 19.232c-.896 3.165-3.245 11.89-4.319 19.934q.213-.02.43-.027a279 279 0 0 1 9.246-.14c3.917 0 6.99.065 9.246.14q.217.008.43.027c-1.074-8.044-3.424-16.769-4.32-19.933A8.96 8.96 0 0 1 24 21a8.96 8.96 0 0 1-5.357-1.768Z\"/><path d=\"M37.14 45c.476 0 .86-1.116.86-1.592c0-2.692-2.064-4.179-4.754-4.269A279 279 0 0 0 24 39c-3.917 0-6.99.064-9.246.14c-2.69.09-4.754 1.576-4.754 4.268c0 .476.384 1.592.86 1.592z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chessPawn
